import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class Cta extends Component {
  render() {
    return (
      <section
        className='section cm-cta bg-cover overlay-light'
        style={{ backgroundImage: 'url(assets/images/bg-cta.jpg)' }}
      >
        <div className='container'>
          <div className='row align-items-center'>
            <div className='col-lg-7 col-md-8'>
              <div className='text-dark'>
                {/* Urgency Badge */}
                <span style={{
                  display: 'inline-block',
                  background: '#dc3545',
                  color: 'white',
                  padding: '6px 14px',
                  borderRadius: '50px',
                  fontSize: '0.8rem',
                  fontWeight: '600',
                  marginBottom: '15px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px'
                }}>
                  <i className="fas fa-bolt mr-2" />
                  Same-Day Repairs Available
                </span>

                <h2 className='h1 mb-15'>Need Your Device Fixed Fast?</h2>
                <p className='mb-20' style={{ fontSize: '1.1rem', color: '#4a4a4a' }}>
                  Don't wait! Our expert technicians are ready to help you right now.
                </p>

                {/* Phone Number - Large */}
                <a
                  href='tel:+12159393933'
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    fontSize: '1.8rem',
                    fontWeight: '700',
                    color: '#007bff',
                    marginBottom: '20px',
                    transition: 'color 0.3s'
                  }}
                >
                  <span className='fas fa-phone-alt mr-15' style={{ fontSize: '1.4rem' }} />
                  (215) 939-3933
                </a>

                {/* CTA Buttons */}
                <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', marginTop: '10px' }}>
                  <a
                    href='tel:+12159393933'
                    className='btn btn-primary btn-pulse initiate-scripts'
                    style={{ padding: '14px 28px' }}
                  >
                    <i className="fas fa-phone-alt mr-2" />
                    Call Now
                  </a>
                  <Link
                    to={'/contact-us'}
                    className='btn btn-primary-outline initiate-scripts'
                    style={{ padding: '14px 28px' }}
                  >
                    <i className="fas fa-calendar-alt mr-2" />
                    Book Appointment
                  </Link>
                </div>
              </div>
            </div>

            {/* Trust Indicators */}
            <div className='col-lg-5 col-md-4 mt-4 mt-lg-0'>
              <div style={{
                background: 'rgba(255, 255, 255, 0.9)',
                padding: '25px',
                borderRadius: '12px',
                boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                  <i className="fas fa-shield-alt text-primary mr-3" style={{ fontSize: '1.5rem' }} />
                  <div>
                    <strong>Warranty Included</strong>
                    <p className='mb-0 small text-muted'>All repairs come with warranty</p>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                  <i className="fas fa-clock text-primary mr-3" style={{ fontSize: '1.5rem' }} />
                  <div>
                    <strong>Quick Turnaround</strong>
                    <p className='mb-0 small text-muted'>Most repairs done same day</p>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <i className="fas fa-dollar-sign text-primary mr-3" style={{ fontSize: '1.5rem' }} />
                  <div>
                    <strong>Free Estimates</strong>
                    <p className='mb-0 small text-muted'>No obligation quotes</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Cta;
